'use strict';
import {AssetViewOverview} from './components/AssetViewOverview';
import {AssetController} from './controllers/AssetController';
import {AssetHomeController, CacheTemplates as AssetHomeTemplates} from './controllers/AssetHomeController';
import {AssetsCreateController} from './controllers/AssetsCreateController';
import {CreateAssetController, CreateAssetDirective} from './directives/CreateAssetDirective';
import {AssetDomainProvider} from './domain/AssetDomain';
import {routerConfig} from './router';
import {AssetEditorFactory, injector as AssetEditorFactoryInjector} from './services/AssetEditorFactory';


const angular = require('angular');

module.exports = angular
  .module('app.assets', [])
  .config(routerConfig)
  .run(AssetEditorFactoryInjector)
  .provider('AssetDomain', AssetDomainProvider)
  .constant('AssetViewOverview', AssetViewOverview)
  .factory('AssetEditorFactory', AssetEditorFactory)

  .directive('createAsset', CreateAssetDirective)
  .controller('CreateAssetController', CreateAssetController)

  .controller('AssetController', AssetController)
  .controller('AssetHomeController', AssetHomeController)
  .run(AssetHomeTemplates)
  .controller('AssetsCreateController', AssetsCreateController)
;



// WEBPACK FOOTER //
// ./src/js/assets/index.js